import React, { useEffect, useRef, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { resetMemberPassword } from '../../../api/apiServices';
import { Link, useNavigate, useLocation } from 'react-router-dom';


const VerifySecretCode = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/home";

    const userRef = useRef();

    useEffect(() => {
        userRef.current.focus();
    }, [])


    const prefix = 'PF-'
    const [secret_code, setSecretCode] = useState('')

    const handleOnChange = (e) => {
        const input = e.target.value
        setSecretCode(e.target.value)
    }



    const handleSubmit = (e) => {
        e.preventDefault()
        if (secret_code.substring(0, 6) === "PF-PF-") {
            toast.error("Enter only the digit numbers", {
                duration: 5000,
                className: "toast-message",
            });
            return false
        }
        resetMemberPassword(secret_code).then((res) => { 
            if (res.success) { 
                navigate(`/reset_portal_password/${secret_code}`);
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
                userRef.current.focus();
                return false
            }
        })        

    }

    const verifyCode = (
        <>
            <form onSubmit={handleSubmit} >
                <div className="secret-code">
                    <h2>VERIFY SECRET CODE</h2>
                    <p>Check your email and enter your secret code to reset your password</p>
                </div>
                <div className="form-group row">
                    <label htmlFor="secret_code" className="col-sm-4"></label>
                    <div className="col-sm-4">
                        <input
                            ref={userRef}
                            type="secret_code"
                            name="secret_code"
                            value={prefix + secret_code.substring(prefix.length)}
                            onChange={handleOnChange}
                            required
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="panel-footer">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center'}}>
                            <button type="submit" className="btn btn-success" >Submit</button>
                        </div>
                </div>
            </form>
        </>
    )
    return (
        <>
            <section className="content-header">
                <Toaster toastOptions={{ position: "top-center" }} />
                <h1><i className="fa fa-envelope"></i>Forgot Password</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Member Verification</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                <div className="contact-container">
                                    {verifyCode}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default VerifySecretCode